var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 47,
    viewBox: "0 0 53 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trophy-solid",
    d: "M49.833,5.75H40.444V2.156A2.156,2.156,0,0,0,38.278,0H13.722a2.156,2.156,0,0,0-2.167,2.156V5.75H2.167A2.156,2.156,0,0,0,0,7.906v5.031c0,3.207,2.031,6.5,5.588,9.047a21.211,21.211,0,0,0,9.931,3.746,19.92,19.92,0,0,0,6.148,6.613v6.469H17.333c-3.187,0-5.778,1.86-5.778,5.031v1.078A1.084,1.084,0,0,0,12.639,46H39.361a1.084,1.084,0,0,0,1.083-1.078V43.844c0-3.171-2.591-5.031-5.778-5.031H30.333V32.344a19.92,19.92,0,0,0,6.148-6.613,21.138,21.138,0,0,0,9.931-3.746C49.96,19.442,52,16.145,52,12.938V7.906A2.156,2.156,0,0,0,49.833,5.75ZM8.965,17.322c-2.2-1.581-3.187-3.342-3.187-4.384V11.5h5.8a32.125,32.125,0,0,0,1.156,7.745A14.575,14.575,0,0,1,8.965,17.322Zm37.258-4.384c0,1.446-1.6,3.243-3.187,4.384a14.632,14.632,0,0,1-3.774,1.923A32.125,32.125,0,0,0,40.417,11.5h5.8Z",
    transform: "translate(0.5 0.5)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp9);
export default __webpack_public_path__ + "static/media/exp-9.ef6f2dda83b54f7529c41b26fd6fda5b.svg";
export { ForwardRef as ReactComponent };